import React, { useRef, useEffect } from 'react';
import { FusedRecord } from '../../core/types/fusion';

interface AcousticViewProps {
  records: FusedRecord[];
}

export const AcousticView: React.FC<AcousticViewProps> = ({ records }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.fillStyle = '#0f172a';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (records.length === 0) {
      ctx.fillStyle = '#64748b';
      ctx.font = '14px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('声场空间散点视图 - 等待实验数据中...', canvas.width / 2, canvas.height / 2);
      return;
    }

    const scaleX = canvas.width / 640;
    const scaleY = canvas.height / 480;

    for (const rec of records) {
      const posA = rec.cameraAPosition;
      if (!posA || posA.status === 'lost') continue;

      const px = posA.filteredPosition.x * scaleX;
      const py = posA.filteredPosition.y * scaleY;

      // Color mapping from dBFS
      const norm = Math.max(0, Math.min(1, (rec.audioFeatures.dbfs + 90) / 90));
      const radius = 6 + norm * 14;

      const hue = (1 - norm) * 240;
      ctx.fillStyle = `hsla(${hue}, 90%, 55%, 0.6)`;
      ctx.beginPath();
      ctx.arc(px, py, radius, 0, 2 * Math.PI);
      ctx.fill();

      // Measured point center dot
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.arc(px, py, 2, 0, 2 * Math.PI);
      ctx.fill();
    }
  }, [records]);

  return (
    <div>
      <div className="alert-box alert-info" style={{ marginBottom: 12 }}>
        💡 声场视图展示标记物空间位置与对应时刻音频强度 (dBFS) 的关系。白色实心点为实测物理数据点，圆环半径代表相对声强。
      </div>

      <div className="camera-card" style={{ width: '100%', height: '500px' }}>
        <canvas ref={canvasRef} width={800} height={500} style={{ width: '100%', height: '100%', display: 'block' }} />
      </div>
    </div>
  );
};
